// icons
import {
  HiRss,
  HiHeart,
  HiLocationMarker,
  HiEye,
  HiEyeOff,
} from 'react-icons/hi';
import { RiMoneyDollarCircleFill } from 'react-icons/ri';
import { ReactElement } from 'react';

interface ProductFlag {
  value: string;
  icon: ReactElement;
}

interface FlagsDictionary {
  isPrivate: ProductFlag;
  isOnline: ProductFlag;
  isPublic: ProductFlag;
  forProfit: ProductFlag;
  notForProfit: ProductFlag;
  notOnline: ProductFlag;
}

const ProductFlagsDictionary: FlagsDictionary = {
  isPrivate: { value: 'Private', icon: <HiEyeOff /> },
  isOnline: { value: 'Online', icon: <HiRss /> },
  isPublic: { value: 'Public', icon: <HiEye /> },
  forProfit: { value: 'Forprofit', icon: <RiMoneyDollarCircleFill /> },
  notForProfit: { value: 'Nonprofit', icon: <HiHeart /> },
  notOnline: { value: 'On Campus', icon: <HiLocationMarker /> },
};

export default ProductFlagsDictionary;
